<template>
  <v-container fluid fill-height class="pa-0">
    <Toolbar :menu_itens="menu_itens"/>
    <v-navigation-drawer
      v-if="dialogVouchers"
      v-model="dialogVouchers"
      fixed
      right
      temporary
      width="450"
    >
      <compras-em-dinheiro />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="dialogRelatorioEmpresa"
      v-model="dialogRelatorioEmpresa"
      fixed
      right
      temporary
      width="450"
    >
      <relatorio-empresa />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="dialogRelatorioPix"
      v-model="dialogRelatorioPix"
      fixed
      right
      temporary
      width="450"
    >
      <relatorio-pix />
    </v-navigation-drawer>
    <v-content style="height: 100%">
      <Navbar :menu_itens="menu_itens" v-if="user && toolbar"/>
      <v-alert
        v-if="updateVersion || hasNewVersion"
        :value="true"
        type="error"
        class="pa-1"
        icon="update"
      >
        <v-layout>
          <div class="mt-2">Uma nova atualização está disponível</div>
          <v-spacer></v-spacer>
          <v-btn small @click="atualizar">Atualizar</v-btn>
        </v-layout>
      </v-alert>

      <div
        id="scrolling-techniques"
        class="scroll-y"
        :style="{ 'max-height': 'calc(100vh - 64px)', 'margin-top': toolbar ? '7em' : '0em' }"
      >
        <router-view></router-view>
      </div>
      <v-layout justify-center>
        <v-flex xs8>
          <precos-list v-if="frentista && !hide"></precos-list>
        </v-flex>
      </v-layout>
    </v-content>
    <v-dialog v-if="cadPin" v-model="cadPin" persistent max-width="360">
      <cad-pin @fechar="cadPin = false" :frentistaSelecionado="frentista" />
    </v-dialog>
    <v-dialog
      v-if="dialogSelecionar"
      v-model="dialogSelecionar"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <selecionar-frentista
        @fechar="dialogSelecionar = false"
        :frentista="frentista"
      />
    </v-dialog>
    <v-dialog v-if="dialogCobranca" v-model="dialogCobranca" persistent width="450">
      <dialog-cobranca
        @fechar="dialogCobranca = false"
        :frentistaSelecionado="frentista"
      />
    </v-dialog>
    <v-dialog v-model="dialogCashback" v-if="dialogCashback" width="50em">
      <voucher-cashback
        @fechar="dialogCashback=false"
      />
    </v-dialog>
    <v-dialog v-model="dialogPremios" v-if="dialogPremios" width="50em">
      <voucher-premio
        @fechar="dialogPremios=false"
      />
    </v-dialog>
    <v-dialog v-model="dialogCashPosto" v-if="dialogCashPosto" width="50em">
      <cash-posto
        @fechar="dialogCashPosto=false"
      />
    </v-dialog>
    <v-dialog v-model="dialogAssinatura" v-if="dialogAssinatura" width="50em">
      <assinatura
        @fechar="dialogAssinatura=false"
      />
    </v-dialog>
    <v-dialog v-model="dialogSugestaoFidelize" v-if="dialogSugestaoFidelize" width="50em">
      <sugestao-fidelize
        @fechar="dialogSugestaoFidelize=false"
      />
    </v-dialog>
    <mensagem-erro></mensagem-erro>
    <mensagem-sucesso></mensagem-sucesso>
  </v-container>
</template>
<script>

import CadPin from '@/components/dialogs/CadPin'
import ComprasEmDinheiro from '@/components/dialogs/ComprasEmDinheiro'
import RelatorioEmpresa from '@/components/dialogs/RelatorioEmpresa'
import RelatorioPix from '@/components/dialogs/RelatorioPixRecebido'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'
import DialogCobranca from '@/components/dialogs/DialogCobranca'
import PrecosList from '@/components/PrecosList'
import VoucherPremio from '@/components/dialogs/VoucherPremio'
import VoucherCashback from '@/components/dialogs/VoucherCashpostoEmpresa'
import CashPosto from '@/components/dialogs/CashPosto'
import Assinatura from '@/components/dialogs/Assinatura'
import SugestaoFidelize from '@/components/dialogs/SugestaoFidelize'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { version, name } from '../../../package.json'
import Toolbar from '@/components/Toolbar.vue'
import Navbar from '@/components/NavBar.vue'
import MensagemErro from '@/components/dialogs/MensagemErro'
import MensagemSucesso from '@/components/dialogs/MensagemSucesso'

export default {
  components: {
    ComprasEmDinheiro,
    PrecosList,
    CadPin,
    RelatorioEmpresa,
    RelatorioPix,
    SelecionarFrentista,
    DialogCobranca,
    VoucherPremio,
    CashPosto,
    Assinatura,
    VoucherCashback,
    Toolbar,
    Navbar,
    MensagemErro,
    MensagemSucesso,
    SugestaoFidelize
  },
  data () {
    return {
      hide: true,
      text: 'Esconder combustíveis',
      dialogSelecionar: false,
      voucher: null,
      dialogVouchers: false,
      dialogPremios: false,
      dialogRelatorioEmpresa: false,
      dialogRelatorioPix: false,
      dialogCashPosto: false,
      dialogCashback: false,
      dialogAssinatura: false,
      dialogSugestaoFidelize: false,
      database: null,
      listener: null,
      cadPin: false,
      dialogUpdate: false,
      dialogCobranca: false,
      toolbar: false,
      largura_tela: 0
    }
  },
  mounted () {
    this.database = firebase.firestore()
    if (!this.user) {
      this.$router.push('/')
    }
  },
  watch: {
    versao (val) {
      this.$store.dispatch('verificarAtualizacao', {
        name: name,
        version: val
      })
    },
    user (val) {
      if (val) {
        let document = this.database
          .collection(val.frentista.posto ? `postos` : 'empresas')
          .doc(val.frentista.posto ? `${val.frentista.posto.cnpj}` : `${val.frentista.empresa.cnpj}`)
          .collection('vouchers-lidos')
          .orderBy('timestamp', 'desc')
          .limit(1)
        this.listener = document.onSnapshot(this.showSnapshot, err => {
          console.log(err)
        })
      } else if (this.listener) {
        this.listener()
      } else {
        this.$router.push('/')
      }
    }
    // hide (val) {
    //   this.items[this.items.length - 1].text = !val ? 'Esconder combustíveis' : 'Mostrar combustíveis'
    // }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    historyVouchers () {
      return this.$store.getters.historyVouchers
    },
    frentista () {
      return this.$store.getters.frentista
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    hasNewVersion () {
      return this.$store.getters.hasNewVersion
    },
    versao () {
      return this.$store.getters.versao
    },
    updateVersion () {
      return this.$store.getters.versao !== version
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    },
    tela () {
      return Number(window.innerWidth)
    },
    filtrosFarmacia () {
      if (!this.empresa) return true
      if (Array.isArray(this.empresa.subcategorias) && this.empresa.subcategorias.includes(54)) {
        return false
      }
      return true
    },
    menu_itens () {
      // Tipo de vendedor 0 = Todos, 1 = Posto, 2 = Empresa
      let itens = [
        {
          icon: 'home',
          text: 'Início',
          funcao: this.showHome,
          color: 'gray',
          tipo_vendedor: 0,
          condicao: true
        },
        {
          icon: 'history',
          text: 'Histórico',
          funcao: this.showHistory,
          color: 'gray',
          tipo_vendedor: 0,
          condicao: true
        },
        {
          icon: 'people',
          text: 'Clientes',
          funcao: this.showClientes,
          color: 'gray',
          tipo_vendedor: 2,
          condicao: true
        },
        {
          icon: 'local_atm',
          text: 'Pagamento no Local',
          funcao: this.showVendasPosPagas,
          color: 'success',
          tipo_vendedor: 0,
          condicao: true
        },
        {
          icon: 'currency_exchange',
          text: 'Voucher cashback',
          funcao: this.showVouchersCashback,
          color: 'teal',
          tipo_vendedor: 1,
          condicao: true
        },
        {
          icon: 'pix',
          text: 'PIX',
          funcao: this.showPix,
          color: 'teal',
          tipo_vendedor: 0,
          condicao: this.filtrosFarmacia
        },
        {
          icon: 'receipt',
          text: 'PIX recebidos',
          funcao: this.showReceivedPix,
          color: 'yellow lighten-3',
          tipo_vendedor: 0,
          condicao: this.filtrosFarmacia
        },
        {
          icon: 'card_giftcard',
          text: 'Prêmios',
          funcao: this.showPrizes,
          color: 'error',
          tipo_vendedor: 0,
          condicao: this.filtrosFarmacia
        },
        {
          icon: 'paid',
          text: 'Cashback',
          funcao: this.showCashPosto,
          color: 'success',
          tipo_vendedor: 0,
          condicao: this.filtrosFarmacia
        },
        {
          icon: 'edit',
          text: 'Assinatura do Usuário',
          funcao: this.showUserSignature,
          color: 'success',
          tipo_vendedor: 0,
          condicao: this.filtrosFarmacia
        },
        {
          icon: 'people',
          text: this.posto ? 'Frentistas' : 'Funcionários',
          funcao: this.showAttendants,
          color: 'blue-grey darken-1',
          tipo_vendedor: 0,
          condicao: this.frentista && this.frentista.gerente
        },
        {
          icon: this.posto ? 'local_gas_station' : 'local_mall',
          text: 'Itens a Venda',
          funcao: this.toggleItens,
          color: 'primary',
          tipo_vendedor: 0,
          condicao: this.frentista && this.frentista.gerente && this.frentista.controle_precos
        },
        {
          icon: 'receipt_long',
          text: 'Pedidos',
          funcao: this.showPlanosAssinatura,
          color: 'success',
          tipo_vendedor: 2,
          condicao: true
        },
        {
          icon: 'emoji_objects',
          text: 'Sugestão de assinatura',
          funcao: this.showSugestaoFidelize,
          color: 'success',
          tipo_vendedor: 2,
          condicao: this.empresa && Array.isArray(this.empresa.subcategorias) && this.empresa.subcategorias.includes(54)
        }
      ]

      return itens.filter(item => {
        // Se condicao do item for false → não mostra
        const passaCondicao = ('condicao' in item) ? !!item.condicao : true
        if (!passaCondicao) return false

        // Regras por tipo de vendedor
        if (this.posto) {
          // Para posto: tipo 0 ou 1
          return item.tipo_vendedor === 0 || item.tipo_vendedor === 1
        }
        if (this.empresa) {
          // Para empresa: tipo 0 ou 2
          return item.tipo_vendedor === 0 || item.tipo_vendedor === 2
        }
        return false
      })
    }
  },
  created () {
    this.$store.dispatch('verificarAtualizacao', {
      name: name,
      version: version
    })
    this.largura_tela = this.tela
    if (this.largura_tela >= 1264) {
      this.menu = true
    } else {
      this.toolbar = true
    }
  },
  methods: {
    showHome () {
      this.$router.push('/home')
    },
    showHistory () {
      this.$router.push('/historico')
    },
    showVendasPosPagas () {
      this.$router.push('/vendas-pos-pagas')
    },
    showVouchersCashback () {
      this.dialogCashback = true
    },
    showCompanyVoucher () {
      this.dialogRelatorioEmpresa = true
    },
    showPix () {
      this.dialogCobranca = true
    },
    showReceivedPix () {
      this.dialogRelatorioPix = true
    },
    showPrizes () {
      this.dialogPremios = true
    },
    showCashPosto () {
      this.dialogCashPosto = true
    },
    showUserSignature () {
      this.dialogAssinatura = true
    },
    showAttendants () {
      this.$router.push('/funcionarios')
    },
    toggleItens () {
      this.$router.push('/itens')
    },
    showClientes () {
      this.$router.push('/meus-clientes')
    },
    showPlanosAssinatura () {
      this.$router.push('/pedidos')
    },
    showSugestaoFidelize () {
      this.dialogSugestaoFidelize = true
    },
    showCadPin () {
      this.cadPin = true
    },
    atualizar () {
      this.$store.dispatch('atualizarVersao', {
        name: name,
        version: version
      })
      window.location.reload(true)
    },
    showSnapshot (snapshot) {
      snapshot.docChanges().forEach(change => {
        if (change.type === 'added') {
          this.$store.dispatch('addVoucherHistory', change.doc.data())
        }
      })
    }
  }
}
</script>
